import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
} from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

import {
  FETCH_CUSTOMERS_IN_CONNECTED_CUSTOMER_USER,
  FETCH_CUSTOMERS_IN_CONNECTED_CUSTOMER_USER_SUCCESS,
  FETCH_CUSTOMERS_IN_CONNECTED_CUSTOMER_USER_FAILURE,
} from "@utils/actionTypes";
import { useStore } from "@store/store";
import Loader from "@components/loader";
import Pagination from "@components/pagination";
import API from "@services/axios";
import { TableStyle } from "./style";
import ListCustomerPopup from "../list-customer-popup";

function TableListing(props) {
  const classes = TableStyle();
  const [state, dispatch] = useStore();
  const [openListCustomer, setOpenListCustomer] = useState(false);
  const [customerData, setCustomerData] = useState([]);

  const handleOpenListCustomer = userData => {
    getCustomers(userData.id);
    setOpenListCustomer(true);
  };
  const handleCloseListCustomer = () => {
    setOpenListCustomer(false);
    setCustomerData([]);
  };

  const getCustomers = id => {
    dispatch({ type: FETCH_CUSTOMERS_IN_CONNECTED_CUSTOMER_USER });
    API.get(`connectedCustomer/${id}/customers`)
      .then(response => {
        setCustomerData(response.data.data);
        dispatch({
          type: FETCH_CUSTOMERS_IN_CONNECTED_CUSTOMER_USER_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_CUSTOMERS_IN_CONNECTED_CUSTOMER_USER_FAILURE,
          payload: err,
        });
      });
  };

  return (
    <>
      <div className={classes.TableWrapper}>
        <Loader
          loading={
            state?.connectedUser?.loading ||
            state?.connectedUser?.resendWelcomeEmailLoading ||
            state?.common?.loadingParentCustomers
          }
        />
        <TableContainer component={Paper} className={classes.customTable}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="name">
                  Name{" "}
                  <TableSortLabel
                    direction={props.orderBy === "name" ? props.order : "desc"}
                    active={true}
                    onClick={(e) => props.handleSorting(e, "name")}
                  />
                </TableCell>
                <TableCell className="email">Email</TableCell>
                <TableCell className="customer">Customer</TableCell>
                <TableCell className="status">Status</TableCell>
                <TableCell className="link"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {state?.connectedUser?.connectedUsers?.count === 0 ? (
                <TableRow>
                  <TableCell>No Data Found</TableCell>
                </TableRow>
              ) : (
                state?.connectedUser?.connectedUsers?.rows?.map(
                  (item, index) => (
                    <TableRow key={item.id ?? index}>
                      <TableCell className="name">{item.name}</TableCell>
                      <TableCell className="email">{item.email}</TableCell>
                      <TableCell
                        className="customer"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenListCustomer(item)}
                      >
                        {item.customerNames}
                      </TableCell>
                      <TableCell className="status">
                        <FiberManualRecordIcon
                          style={{
                            fontSize: 14,
                            color: item.status ? "green" : "#ccc",
                            marginRight: 5,
                          }}
                        />
                        {item.status ? "Active" : "Inactive"}
                      </TableCell>
                      <TableCell className="link">
                        <div className="link-wrapper">
                          <span
                            className="edit-link"
                            onClick={() => props.handleEdit(item)}
                          >
                            Edit
                          </span>
                          <span
                            className="delete-link"
                            onClick={() => props.handleOpen(item)}
                          >
                            Delete
                          </span>
                          {item.welcomeEmailSent ? (
                            <span
                              className="resend-link"
                              style={{ pointerEvents: "none" }}
                            ></span>
                          ) : (
                            <span
                              className="resend-link"
                              onClick={() => props.handleResend(item)}
                            >
                              Resend
                            </span>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  )
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {state?.connectedUser?.connectedUsers?.count !== 0 && (
          <div className="pagination-wrapper">
            <Pagination
              count={state?.connectedUser?.connectedUsers?.count}
              page={props.page}
              handleChangePage={props.handleChangePage}
              rowsPerPage={props.rowsPerPage}
              handleChangeRowsPerPage={props.handleChangeRowsPerPage}
            />
          </div>
        )}
      </div>
      <ListCustomerPopup
        open={openListCustomer}
        handleClose={handleCloseListCustomer}
        customerData={customerData}
      />
    </>
  );
}
export default TableListing;
